/* import __COLOCATED_TEMPLATE__ from './asset-invalid-selection.hbs'; */
import { computed } from '@ember/object';
import LSGModalBase from './lsg/lsg-modal-dialog-base';
import { closeModal } from 'sh-www/utils/modal-controls';

/**
 * The modal for displaying errors after selecting files to attach.
 */
export default LSGModalBase.extend({
  propertyDefaults: {
    /**
     * @param {Object[]} errors The array of errors.
     */
    errors: null,
  },

  /**
   * @type {Boolean} Whether there is only one error.
   */
  _hasOnlyOneError: computed('model.errors.[]', function() {
    return this.get('model.errors.length') === 1;
  }),

  actions: {
    onOKClicked() {
      closeModal(this);
    },
  },
});
